
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/materiali/[slug]",
      function () {
        return require("private-next-pages/materiali/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/materiali/[slug]"])
      });
    }
  